import MenuItem from '@material-ui/core/MenuItem';

import SettingsMenu from '~/components/SettingsMenu/SettingsMenu';

class ListResponsesSettingsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onClickExportResponses = () => {
    const { exportResponses } = this.props;
    this.setState({ open: false });
    exportResponses();
  };

  onClickChooseColumns = () => {
    const { onClickChooseColumns } = this.props;
    this.setState({ open: false });
    onClickChooseColumns();
  };

  render() {
    const { open } = this.state;

    return (
      <SettingsMenu open={open} squareIcon>
        <MenuItem onClick={this.onClickChooseColumns}>Choose Columns</MenuItem>

        <MenuItem onClick={this.onClickExportResponses}>
          Download as CSV
        </MenuItem>
      </SettingsMenu>
    );
  }
}

ListResponsesSettingsMenu.propTypes = {
  exportResponses: PropTypes.func.isRequired,
  onClickChooseColumns: PropTypes.func.isRequired,
};

export default ListResponsesSettingsMenu;
